import React from 'react';

function WhoAreWePage() {
  return (
    <div className="py-8 md:py-12 max-w-[1280px] mx-auto px-4 2xl:px-0">
      {/* Section Header */}
      <div className=" flex items-center mb-4">
        <div>
          <h2 className="text-[30px] my-2">Who We Are</h2>
          <div className="border-b-4 border-green-600 w-[100px] md:w-[150px]" />
        </div>
      </div>

      {/* Content */}
      <div className=" flex justify-between items-center max-sm:flex-col">
        <div className="w-full md:w-[65%]">
          <h3 className="text-[16px] md:text-[18px] font-normal leadering-relaxed">
            <strong className="text-[20px]">Integrated Holistic Psychotherapy</strong>{" "}
            is a Consultancy and Counseling firm specialized in offering quality
            services in a safe, confidential and supportive environment for
            individuals, couples, families and corporate groups with caring
            professional mental health practitioners to receive the healing and
            restoration you need.
          </h3>
        </div>
      </div>
    </div>
  );
}

export default WhoAreWePage;
